import { useEffect } from 'react'
import { useDrag } from 'react-dnd'
import InstantGridRow, { InstantGridRowProps } from './InstantGridRow'
import { beginDragRow, endDragRow, ORDER_DND_TYPE } from './instantGridDnd'

interface InstantGridDraggableRowProps<T> extends InstantGridRowProps<T> {
  dragPreview?: string
}

function InstantGridDraggableRow<T>(props: InstantGridDraggableRowProps<T>) {
  const { dragPreview, setRef, row, id, index, onDragEnd, ...restProps } = props

  const [, connectDragSource, connectDragPreview] = useDrag(
    () => ({
      type: ORDER_DND_TYPE,
      item: () => beginDragRow({ id, index }),
      end: (_item, monitor) => endDragRow({ id, index, onDragEnd }, row, monitor.getDropResult())
    }),
    [id, index, row, onDragEnd]
  )

  useEffect(() => {
    if (dragPreview && connectDragPreview) {
      const img = new Image()
      img.src = dragPreview
      img.onload = () => connectDragPreview(img)
    }
  }, [dragPreview, connectDragPreview])

  const setRefWithDrag = (el: any) => {
    setRef?.(el)
    if (el) {
      connectDragSource(el)
    }
  }

  return (
    <InstantGridRow
      isDragEnabled={true}
      setRef={setRefWithDrag}
      row={row}
      id={id}
      index={index}
      onDragEnd={onDragEnd}
      {...restProps}
    />
  )
}

export default InstantGridDraggableRow
